import React from 'react';
import { Spin } from 'antd';
import constants from 'data/constants';
import useWindowDimensions from 'data/useWindowDimensions';

const Loader = props => {
  const { width } = useWindowDimensions();
  return (
    <div
      style={{
        position: 'absolute',
        zIndex: 1001,
        left: 0,
        right: 0,
        top: 0,
        height: '100%',
        background: 'rgba(2555,255,255,0.5)',
        display: !props.isLoading ? 'none' : 'block'
      }}>
      <div
        style={{
          position: 'fixed',
          zIndex: 10,
          left: width < constants.TABLET_WIDTH ? 80 : 200,
          right: 0,
          top: 64,
          height: 'calc(100vh - 60px)',
          display: !props.isLoading ? 'none' : 'flex',
          justifyContent: 'center',
          alignItems: 'center'
        }}>
        <div style={{ textAlign: 'center' }}>
          <Spin spinning={props.isLoading} tip={props.tip} size="large" />
        </div>
      </div>
    </div>
  );
};

export default Loader;
